import script from "./newsview.vue?vue&type=script&setup=true&lang=js"
export * from "./newsview.vue?vue&type=script&setup=true&lang=js"

import "./newsview.vue?vue&type=style&index=0&id=50ae4383&scoped=true&lang=css"

import exportComponent from "D:\\project\\安可控\\Dtsc.Official.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ae4383"]])

export default __exports__